import { render, staticRenderFns } from "./AccountOrder.vue?vue&type=template&id=da245872"
import script from "./AccountOrder.vue?vue&type=script&lang=js"
export * from "./AccountOrder.vue?vue&type=script&lang=js"
import style0 from "./AccountOrder.vue?vue&type=style&index=0&id=da245872&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports